// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Wizzy — classic search page */

/* ---- Sidebar ---- */

.wz-sider {
  border-right: 1px solid var(--wz-line);
  box-shadow: 1px 0 0 rgba(18, 22, 15, 0.02);
}

.wz-sider-inner {
  padding: 20px 18px 28px;
}

.wz-user-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 14px 12px;
  margin-bottom: 18px;
  border: 1px solid var(--wz-line);
  border-radius: var(--wz-r-md);
  background:
    linear-gradient(180deg, rgba(182, 206, 59, 0.05) 0%, rgba(182, 206, 59, 0) 70%),
    var(--wz-card);
}

.wz-user-name {
  max-width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--wz-text);
}

.wz-logout-btn {
  color: var(--wz-text-3) !important;
  font-size: 12px;
}

.wz-logout-btn:hover {
  color: var(--wz-text) !important;
}

/* Live search card */
.wz-live-card {
  padding: 12px 14px;
  margin-bottom: 22px;
  border: 1px solid var(--wz-line);
  border-radius: var(--wz-r-md);
  background: var(--wz-card);
  transition: border-color 0.25s ease, background 0.25s ease;
}

.wz-live-card-on {
  border-color: var(--wz-green-tint-2);
  background:
    linear-gradient(180deg, rgba(182, 206, 59, 0.09) 0%, rgba(182, 206, 59, 0.02) 100%),
    var(--wz-card);
}

.wz-live-card-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.wz-live-title {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  font-weight: 600;
  font-size: 13.5px;
  color: var(--wz-text);
}

.wz-live-hint {
  font-size: 11.5px;
  color: var(--wz-text-3);
  margin-top: 6px;
  padding-left: 17px;
}

/* Filter section headings (h3 in Sidebar.jsx) */
.wz-sider h3 {
  font-family: var(--wz-font-ui);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: var(--wz-text-2);
  margin-bottom: 8px;
}

/* Range readouts under sliders */
.wz-range-readout {
  font-size: 12px;
  color: var(--wz-text-2);
  font-variant-numeric: tabular-nums;
  background: var(--wz-bg);
  border: 1px solid var(--wz-line);
  border-radius: 6px;
  padding: 3px 10px;
  display: inline-block;
}

.wz-empty-box {
  padding: 14px 12px;
  background: var(--wz-bg);
  border: 1px dashed var(--wz-line-2);
  border-radius: var(--wz-r-sm);
  font-size: 12px;
  color: var(--wz-text-3);
  text-align: center;
  margin-top: 12px;
}

.wz-hint-center {
  font-size: 11px;
  color: var(--wz-text-3);
  text-align: center;
  margin-top: 8px;
}

/* ---- Header ---- */

.wz-header {
  display: flex;
  align-items: center;
  gap: 16px;
  background: var(--wz-card) !important;
  padding: 0 28px !important;
  border-bottom: 1px solid var(--wz-line);
}

.wz-header-logo {
  height: 38px;
}

.wz-header-divider {
  width: 1px;
  height: 26px;
  background: var(--wz-line-2);
}

.wz-header-wordmark {
  font-size: 21px;
}

/* ---- Content ---- */

.wz-content {
  margin: 24px 24px 32px !important;
  padding: 28px 32px 36px;
  background: var(--wz-card);
  border: 1px solid var(--wz-line);
  border-radius: var(--wz-r-lg);
  box-shadow: var(--wz-shadow-sm);
}

.wz-page-title {
  font-size: 30px;
  margin-bottom: 4px;
}

/* Search button */
.search-button {
  height: 46px;
  min-width: 180px;
  font-size: 15px;
  font-weight: 600;
}

/* Kostenschätzung CTA */
.wz-estimate-cta {
  margin-top: 20px;
  margin-bottom: 10px;
  height: 44px;
  background: var(--wz-ink) !important;
  border-color: var(--wz-ink) !important;
  color: #fff !important;
  font-weight: 500;
}

.wz-estimate-cta:hover {
  background: var(--wz-ink-2) !important;
  border-color: var(--wz-ink-2) !important;
  color: var(--wz-green) !important;
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(18, 22, 15, 0.22);
}

/* Loading panel */
.wz-loading-panel {
  text-align: center;
  margin-top: 40px;
  padding: 32px 20px;
  background: var(--wz-bg);
  border: 1px solid var(--wz-line);
  border-radius: var(--wz-r-md);
}

.wz-loading-text {
  margin-top: 12px;
  color: var(--wz-text-2);
}

/* Overview + result cards */
.wz-overview-card .ant-card-body {
  padding: 20px 24px;
}

.wz-result-card .ant-card-head {
  padding: 14px 24px;
}

/* Compact table styling (kept from before, tuned) */
.compact-table .ant-table-thead > tr > th {
  padding: 8px 10px !important;
}

.compact-table .ant-table-tbody > tr > td {
  padding: 6px 10px !important;
  font-size: 12.5px;
}

.compact-table .ant-table-small .ant-table-thead > tr > th {
  padding: 6px 10px !important;
}

.compact-table .ant-table-small .ant-table-tbody > tr > td {
  padding: 4px 10px !important;
}

/* Table wrapper hairline */
.ant-table-wrapper {
  border: 1px solid var(--wz-line);
  border-radius: var(--wz-r-md);
  overflow: hidden;
}

/* Loading overlay (kept) */
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* Smooth transitions (kept) */
.results-container {
  transition: opacity 0.3s ease;
}

.results-container.loading {
  opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./src/components/SearchInterface.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC,sBAAsB;;AAEtB;EACE,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,6BAA6B;EAC7B;;kBAEgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,6BAA6B;EAC7B,0BAA0B;EAC1B,0DAA0D;AAC5D;;AAEA;EACE,oCAAoC;EACpC;;kBAEgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,uBAAuB;EACvB,kCAAkC;EAClC,wBAAwB;EACxB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mCAAmC;EACnC,6BAA6B;EAC7B,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,qBAAqB;;AAErB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qCAAqC;EACrC,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB;;AAEtB;EACE,iCAAiC;EACjC,uBAAuB;EACvB,0BAA0B;EAC1B,gCAAgC;EAChC,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;EACpC,sCAAsC;EACtC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;EACxC,iCAAiC;EACjC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,oDAAoD;AACpD;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,2BAA2B;AAC3B;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd","sourcesContent":["/* Wizzy — classic search page */\n\n/* ---- Sidebar ---- */\n\n.wz-sider {\n  border-right: 1px solid var(--wz-line);\n  box-shadow: 1px 0 0 rgba(18, 22, 15, 0.02);\n}\n\n.wz-sider-inner {\n  padding: 20px 18px 28px;\n}\n\n.wz-user-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 14px 12px;\n  margin-bottom: 18px;\n  border: 1px solid var(--wz-line);\n  border-radius: var(--wz-r-md);\n  background:\n    linear-gradient(180deg, rgba(182, 206, 59, 0.05) 0%, rgba(182, 206, 59, 0) 70%),\n    var(--wz-card);\n}\n\n.wz-user-name {\n  max-width: 170px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--wz-text);\n}\n\n.wz-logout-btn {\n  color: var(--wz-text-3) !important;\n  font-size: 12px;\n}\n\n.wz-logout-btn:hover {\n  color: var(--wz-text) !important;\n}\n\n/* Live search card */\n.wz-live-card {\n  padding: 12px 14px;\n  margin-bottom: 22px;\n  border: 1px solid var(--wz-line);\n  border-radius: var(--wz-r-md);\n  background: var(--wz-card);\n  transition: border-color 0.25s ease, background 0.25s ease;\n}\n\n.wz-live-card-on {\n  border-color: var(--wz-green-tint-2);\n  background:\n    linear-gradient(180deg, rgba(182, 206, 59, 0.09) 0%, rgba(182, 206, 59, 0.02) 100%),\n    var(--wz-card);\n}\n\n.wz-live-card-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.wz-live-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  font-weight: 600;\n  font-size: 13.5px;\n  color: var(--wz-text);\n}\n\n.wz-live-hint {\n  font-size: 11.5px;\n  color: var(--wz-text-3);\n  margin-top: 6px;\n  padding-left: 17px;\n}\n\n/* Filter section headings (h3 in Sidebar.jsx) */\n.wz-sider h3 {\n  font-family: var(--wz-font-ui);\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.09em;\n  text-transform: uppercase;\n  color: var(--wz-text-2);\n  margin-bottom: 8px;\n}\n\n/* Range readouts under sliders */\n.wz-range-readout {\n  font-size: 12px;\n  color: var(--wz-text-2);\n  font-variant-numeric: tabular-nums;\n  background: var(--wz-bg);\n  border: 1px solid var(--wz-line);\n  border-radius: 6px;\n  padding: 3px 10px;\n  display: inline-block;\n}\n\n.wz-empty-box {\n  padding: 14px 12px;\n  background: var(--wz-bg);\n  border: 1px dashed var(--wz-line-2);\n  border-radius: var(--wz-r-sm);\n  font-size: 12px;\n  color: var(--wz-text-3);\n  text-align: center;\n  margin-top: 12px;\n}\n\n.wz-hint-center {\n  font-size: 11px;\n  color: var(--wz-text-3);\n  text-align: center;\n  margin-top: 8px;\n}\n\n/* ---- Header ---- */\n\n.wz-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  background: var(--wz-card) !important;\n  padding: 0 28px !important;\n  border-bottom: 1px solid var(--wz-line);\n}\n\n.wz-header-logo {\n  height: 38px;\n}\n\n.wz-header-divider {\n  width: 1px;\n  height: 26px;\n  background: var(--wz-line-2);\n}\n\n.wz-header-wordmark {\n  font-size: 21px;\n}\n\n/* ---- Content ---- */\n\n.wz-content {\n  margin: 24px 24px 32px !important;\n  padding: 28px 32px 36px;\n  background: var(--wz-card);\n  border: 1px solid var(--wz-line);\n  border-radius: var(--wz-r-lg);\n  box-shadow: var(--wz-shadow-sm);\n}\n\n.wz-page-title {\n  font-size: 30px;\n  margin-bottom: 4px;\n}\n\n/* Search button */\n.search-button {\n  height: 46px;\n  min-width: 180px;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n/* Kostenschätzung CTA */\n.wz-estimate-cta {\n  margin-top: 20px;\n  margin-bottom: 10px;\n  height: 44px;\n  background: var(--wz-ink) !important;\n  border-color: var(--wz-ink) !important;\n  color: #fff !important;\n  font-weight: 500;\n}\n\n.wz-estimate-cta:hover {\n  background: var(--wz-ink-2) !important;\n  border-color: var(--wz-ink-2) !important;\n  color: var(--wz-green) !important;\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(18, 22, 15, 0.22);\n}\n\n/* Loading panel */\n.wz-loading-panel {\n  text-align: center;\n  margin-top: 40px;\n  padding: 32px 20px;\n  background: var(--wz-bg);\n  border: 1px solid var(--wz-line);\n  border-radius: var(--wz-r-md);\n}\n\n.wz-loading-text {\n  margin-top: 12px;\n  color: var(--wz-text-2);\n}\n\n/* Overview + result cards */\n.wz-overview-card .ant-card-body {\n  padding: 20px 24px;\n}\n\n.wz-result-card .ant-card-head {\n  padding: 14px 24px;\n}\n\n/* Compact table styling (kept from before, tuned) */\n.compact-table .ant-table-thead > tr > th {\n  padding: 8px 10px !important;\n}\n\n.compact-table .ant-table-tbody > tr > td {\n  padding: 6px 10px !important;\n  font-size: 12.5px;\n}\n\n.compact-table .ant-table-small .ant-table-thead > tr > th {\n  padding: 6px 10px !important;\n}\n\n.compact-table .ant-table-small .ant-table-tbody > tr > td {\n  padding: 4px 10px !important;\n}\n\n/* Table wrapper hairline */\n.ant-table-wrapper {\n  border: 1px solid var(--wz-line);\n  border-radius: var(--wz-r-md);\n  overflow: hidden;\n}\n\n/* Loading overlay (kept) */\n.loading-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n/* Smooth transitions (kept) */\n.results-container {\n  transition: opacity 0.3s ease;\n}\n\n.results-container.loading {\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
